/**
 * A wrapper type that encapsulates a file blob and its name.
 * This is useful for file uploads where the filename needs to be preserved
 * across platforms (especially iOS/Android where Blob doesn't have a name property).
 */
export interface FileWithName {
	blob: Blob
	name: string
}

/**
 * Creates a FileWithName object from a blob and filename
 */
export function createFileWithName(blob: Blob, name: string): FileWithName {
	return { blob, name }
}

/**
 * Gets the filename from a FileWithName, with a fallback
 */
export function getFileName(file: FileWithName | null | undefined, fallback = 'Unbenannt'): string {
	return file?.name || fallback
}

export function base64ToBlob(base64: string, contentType: string): Blob {
	const byteString = window.atob(base64)
	const int8Array = Uint8Array.from(byteString, c => c.charCodeAt(0))
	return new Blob([int8Array], { type: contentType })
}
